/* Dispatched by the footer to reopen the cookie preferences, whatever was chosen before. */
export const OPEN_COOKIE_SETTINGS = 'schmitt:open-cookie-settings';
